export const initJobsState = {
    //dueDateDefault: dueDateDefault,
    //dueDateDefaultRaw: new Date(dueDateDefault),
    utilities: [],
    utilsForDropdown:[],
    utilsForDropdownCreate:[],
    selectedUtility: "",
    updating:0,
    jobs:[],
    filteredJobs:[],
    searchString:'',
    selectedStatus:'All',
    newJob:null,
    //showCreateJob:false,
    //selectedFilterBy:'Job Number',
    jobNumber:'',
    sort_dir:"asc",
    sort_col: "job_number",
    //dueDate:new Date(),
    //packetFile: {name: '', type: '', size: ''},
    //foremenForDropdown:[],
    //selectedForeman:{},
    //jobType: 'normal',
    //hospName: '',
    //hospAddress: '',
    //ambMeetup: '',
    canSaveJob:false,
    loadingNewPacket: false,
    //startDate:new Date(),
    //endDate:new Date(),
    newExcel: false,
    excelActiveTab: 'tracking',
    newTickets:null,
    canSaveExcel:false,
}

export const jobsReducer = (state, action) => {
    switch (action.type) {
        case 'utilities':
            return {...state, jobs: {...state.jobs, utilities: action.payload}};
        case 'utilsForDropdown':
            return {...state, jobs: {...state.jobs, utilsForDropdown: action.payload}};
        case 'utilsForDropdownCreate':
            return {...state, jobs: {...state.jobs, utilsForDropdownCreate: action.payload}};
        case 'selectedUtility':
            return {...state, jobs: {...state.jobs, selectedUtility: action.payload}};
        case 'updating':
            return {...state, jobs: {...state.jobs, updating: action.payload}};
        case 'jobs':
            return {...state, jobs: {...state.jobs, jobs: action.payload}};
        case 'filteredJobs':
            return {...state, jobs: {...state.jobs, filteredJobs: action.payload}};
        case 'searchString':
            return {...state, jobs: {...state.jobs, searchString: action.payload}};
        case 'selectedStatus':
            return {...state, jobs: {...state.jobs, selectedStatus: action.payload}};
        case 'newJob':
            return {...state, jobs: {...state.jobs, newJob: action.payload}};
        case 'jobNumber':
            return {...state, jobs: {...state.jobs, jobNumber: action.payload}};
        case 'sort_dir':
            return {...state, jobs: {...state.jobs, sort_dir: action.payload}};
        case 'sort_col':
            return {...state, jobs: {...state.jobs, sort_col: action.payload}};
        case 'canSaveJob':
            return {...state, jobs: {...state.jobs, canSaveJob: action.payload}};
        case 'loadingNewPacket':
            return {...state, jobs: {...state.jobs, loadingNewPacket: action.payload}};
        case 'newExcel':
            return {...state, jobs: {...state.jobs, newExcel: action.payload}};
        case 'excelActiveTab':
            return {...state, jobs: {...state.jobs, excelActiveTab: action.payload}};
        case 'newTickets':
            return {...state, jobs: {...state.jobs, newTickets: action.payload}};
        case 'canSaveExcel':
            return {...state, jobs: {...state.jobs, canSaveExcel: action.payload}};
        default: 
            throw new Error(`${action.type} action.type passed to Lineworx reducer is not defined`);
    }
}